import MatomoMessage from '@/matomo/message/MatomoMessage';
import { MatomoActions } from '@/matomo/MatomoActions';

export default class MatomoContentInteraction {
  private contentInteraction: MatomoMessage;

  private constructor(contentInteraction: MatomoMessage) {
    this.contentInteraction = contentInteraction;
  }
  private static empty(): MatomoContentInteraction {
    return new MatomoContentInteraction(new MatomoMessage([MatomoActions.contentInteraction]));
  }

  public static fromTarget(target: EventTarget): MatomoContentInteraction {
    return MatomoContentInteraction.empty().withTarget(target);
  }

  public withTarget(target: EventTarget): MatomoContentInteraction {
    return new MatomoContentInteraction(this.contentInteraction.with(target));
  }

  public withClickAction(): MatomoContentInteraction {
    return new MatomoContentInteraction(this.contentInteraction.with('click'));
  }

  public publishInteraction() {
    this.contentInteraction.publish();
  }

}
